import React, {useState} from "react";
import {HeaderDashboard, SideNav} from "../Componat/Header and Side Nav/NavComponant";
import Form8Data from "./Form8Data";

export default function () {
    const [isOpen, setIsOpen] = useState(true);
    const toggleSidebar = () => setIsOpen(!isOpen);


    return (
        <div className="d-flex flex-column min-vh-100">
            <HeaderDashboard toggleSidebar={()=>{toggleSidebar()}}/>
            <div className="d-flex flex-grow-1">
                <SideNav isOpen={isOpen}/>

                {/* Main Content */}
                <main className={`p-4 w-100 main`}>
                    {/*<Form8/>*/}
                    <Form8Data/>
                </main>
            </div>
        </div>

    )

}

